import { Component, Input } from '@angular/core';
import { NoahSessionGraphViewModel, NoahSessionGraphPointViewModel } from '../../../models/noah-sessions';
import { NoahSessionPointStatusEnum } from '../../../models/enums';

@Component({
    selector: 'noah-values',
    templateUrl: './noah-values.component.html',
    styleUrls: ['./noah-values.component.scss'],
    standalone: false
})
export class NoahValuesComponent {
    @Input() public graphModel: NoahSessionGraphViewModel;    
    public frequencyItems = ['125', '250', '500', '750', '1K', '1.5K', '2K', '3K', '4K','5K', '6K', '6.3K', '7.1K', '8K', '9K','10K','11.2K','12K','12.5K','14K', '16K','18K','20K'];

    public constructor() {
    }

    public getCellText(item: NoahSessionGraphPointViewModel) {
        switch (item.status) {
            case NoahSessionPointStatusEnum.Nr:
                return 'NR';
            case NoahSessionPointStatusEnum.Unm:
                return 'UNM';
            default:
                return item.value;
        }
    }
}
